import React from 'react'
import App from './App'
import { PublicRouter } from './core/router/router'
import { useTheme } from './core/hooks/use-theme'

export const PublicApp = ({ manifest }) => {
  useTheme()

  return <App router={<PublicRouter manifest={manifest} />} header={false} />
}
